import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { AlertService } from '@main/alert.service';
import { Project } from '@main/project';
import { ProjectService } from '@main/project.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-additional-project-settings-modal',
  imports:[ReactiveFormsModule],
  templateUrl: './additional-project-settings-modal.component.html',
  styleUrl: './additional-project-settings-modal.component.css'
})
export class AdditionalProjectSettingsModalComponent implements OnInit {
  @Output() okay: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  // Properties
  additionalProjectSettingsForm: UntypedFormGroup;
  project: Project;


  constructor(
    private alertService: AlertService,
    private projectService: ProjectService,
    public modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.additionalProjectSettingsForm = new UntypedFormGroup({
      bases: new UntypedFormControl(true),
      removal: new UntypedFormControl(true),
      reviews: new UntypedFormControl(true),
    });
    this.setFormDefaultValue();
  }

  // Set Form Default Value
  setFormDefaultValue(): void {
    this.additionalProjectSettingsForm.controls.bases.setValue(this.project?.optionalStages?.BASES);
    this.additionalProjectSettingsForm.controls.removal.setValue(this.project?.optionalStages?.REMOVAL);
    this.additionalProjectSettingsForm.controls.reviews.setValue(this.project?.optionalStages?.REVIEWS);
  }

  // Update Project
  updateProject(event: Event): void {
    event.stopPropagation();
    if(this.additionalProjectSettingsForm.invalid) return;
    const payload = {
      BASES: this.additionalProjectSettingsForm.value.bases ||true,
      REMOVAL: this.additionalProjectSettingsForm.value.removal,
      REVIEWS: this.additionalProjectSettingsForm.value.reviews ||true
    }
    this.projectService.updateProjectOptionalStages(this.project.id, payload).subscribe({
      next: () => {
        this.alertService.showSuccessAlert('Project Optional Stages Updated');
        this.modal.close();
        this.okay.emit(true);
      },
      error: () => {
        this.alertService.showErrorAlert('Failed to update project optional stages.');
      }
    })
  }

  // Project Form Accessors
  get removal() { return this.additionalProjectSettingsForm.controls.removal; }

}
